import React, {FC} from 'react';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {BaseLensesProductItem} from 'components/baseProductItems/baseLensesProductItem/baseLensesProductItem';
import {RemoveItemButton} from 'components/baseProductItems/removeItemButton/removeItemButton';
import {SubscriptionSupplyBlock} from 'components/miniCart/subscriptionSupplyBlock/subscriptionSupplyBlock';
import {SupplyText} from 'components/miniCart/supplyText/supplyText';

import {NotificationBlock} from 'components/notificationBlock/notificationBlock';

import s from '../miniCartProductItem.scss';

export type PropsType = {
    item: QuoteItemV2;
};

/**
 * Product Contact lenses Item for mini cart
 */
export const MiniCartLensesItem: FC<PropsType> = ({item}) => {
    const productHasNotification =
        item.product.stock?.isOutOfStock || item.product.stock?.isLowStock;
    const {prescription} = item;

    return (
        <div className={s.cartItem}>
            <BaseLensesProductItem
                removeComponent={
                    __BUILD_TYPE__ === 'desktop' && <RemoveItemButton item={item} isMiniCart />
                }
                item={item}
                nameComponent={<p className={s.name}>{item.name}</p>}
            >
                <SubscriptionSupplyBlock
                    item={item}
                    supplyComponent={<SupplyText item={item} longMonth />}
                >
                    <p className={s.text}>
                        Qty: Right {prescription?.od?.boxes} | Left {prescription?.os?.boxes}
                    </p>
                </SubscriptionSupplyBlock>
            </BaseLensesProductItem>
            <NotificationBlock item={item} productHasNotification={productHasNotification} />
        </div>
    );
};
